var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKlarna(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 59 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.973.454H0v12.848h2.973V.454zm4.499 0h2.9a10.152 10.152 0 01-.779 3.95A10.198 10.198 0 017.34 7.745l4.101 5.556H7.777L3.324 7.264l1.149-.871A7.4 7.4 0 006.68 3.778c.521-1.031.792-2.17.79-3.324zM51.78 4.987V4.42h2.654v8.881H51.78v-.567a4.728 4.728 0 01-6.687-1.456 4.665 4.665 0 010-4.834 4.7 4.7 0 011.833-1.724 4.734 4.734 0 014.854.267zm-3.681 5.714c.363.266.796.42 1.245.443a2.37 2.37 0 001.686-.644 2.343 2.343 0 00.737-1.64 2.3 2.3 0 00-1.391-2.106 2.314 2.314 0 00-2.496.442 2.287 2.287 0 00-.576 2.454c.155.42.432.785.795 1.051zM12.303.461h2.8v12.84h-2.8V.462zm27.36 3.715a3.254 3.254 0 00-2.754 1.24V4.42h-2.655v8.881h2.695V8.63a1.87 1.87 0 01.538-1.454 1.892 1.892 0 011.452-.559c1.175 0 1.852.7 1.852 1.98v4.691h2.654V7.653c.027-2.072-1.632-3.477-3.782-3.477zm-16.099.811V4.42h2.654v8.881h-2.654v-.567a4.728 4.728 0 01-6.686-1.456 4.665 4.665 0 010-4.834A4.7 4.7 0 0118.71 4.72a4.734 4.734 0 014.854.267zm-3.679 5.711a2.31 2.31 0 001.244.446 2.374 2.374 0 001.69-.641 2.347 2.347 0 00.739-1.642c0-.448-.131-.886-.378-1.26a2.315 2.315 0 00-3.507-.407 2.286 2.286 0 00-.58 2.451c.155.42.43.787.792 1.053zm10.487-5.123V4.42H27.64v8.882h2.74v-4.15c0-1.4 1.526-2.152 2.588-2.152V4.42a3.334 3.334 0 00-2.595 1.155zm26 4.865a1.686 1.686 0 012.505.75 1.661 1.661 0 01-.171 1.57 1.677 1.677 0 01-1.719.693 1.667 1.667 0 01-1.222-2.263c.124-.304.335-.565.607-.75z",
    fill: "#121318"
  })));
}

export default SvgKlarna;